import React, { useState, useEffect, useContext, useCallback } from "react";
import FilterButtons from "../FilterButtons";
import ServiceItems from "../ServiceItems";
import Loading from "../../../components/Loading";
import { toast } from "react-toastify";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { listServiceService } from "../../../../../services/api/listServiceService";

const SearchBar = ({ onSearch, searchText, setSearchText }) => {
  const handleInputChange = (e) => setSearchText(e.target.value);
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };
  return (
    <div className="flex justify-between items-center h-[42px]">
      <div className="flex gap-6 w-full ">
        <div className="relative w-full flex items-center">
          <input
            type="text"
            placeholder="Tìm kiếm dịch vụ"
            autoComplete="off"
            className="border border-gray-200 rounded-lg px-4 py-2 focus:outline-blue-500 w-full"
            value={searchText}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
          />
          <span
            className="absolute right-3 cursor-pointer"
            onClick={onSearch}
            aria-label="Search"
          >
            <img src="/icons/search-black.svg" alt="Search icon" />
          </span>
        </div>
      </div>
    </div>
  );
};

const findCategory = (response) => {
  const categoryList = [];
  if (Array.isArray(response)) {
    response.forEach((item) => {
      if (!categoryList.find((cat) => cat.id === item.id)) {
        categoryList.push({ id: item.id, name: item.name });
      }
    });
  } else {
    console.error("Expected an array but got:", response);
  }
  return categoryList;
};
const findService = (response) => {
  const serviceList = [];
  if (Array.isArray(response)) {
    response.forEach((item) => {
      if (!serviceList.find((cat) => cat.id === item.id)) {
        serviceList.push({
          id: item.id,
          name: item.name,
          formName: item.formName,
        });
      }
    });
  } else {
    console.error("Expected an array but got:", response);
  }
  return serviceList;
};
const findSearchService = (response) => {
  const serviceList = [];
  if (Array.isArray(response)) {
    response.forEach((item) => {
      if (!serviceList.find((cat) => cat.id === item.id)) {
        serviceList.push({
          id: item._id,
          name: item.serviceName,
          formName: item.formName,
        });
      }
    });
  } else {
    console.error("Expected an array but got:", response);
  }
  return serviceList;
};

const SidePopup = ({ id, isOpen, onClose }) => {
  const { token } = useContext(AuthContext);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [services, setServices] = useState([]);

  const fetchCategory = useCallback(async () => {
    try {
      setLoading(true);
      const response = await listServiceService.get_all_category(token);
      const categories = findCategory(response.categories);
      setCategory(categories);
      setSelectedCategory(categories[0]);
    } catch (error) {
      toast.dismiss();
      toast.error(
        error.response
          ? `${error.response?.data?.message}`
          : "Không thể kết nối tới server. Vui lòng kiểm tra mạng."
      );
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  const fetchService = useCallback(
    async (category_id) => {
      try {
        setFetchLoading(true);
        const response = await listServiceService.get_service_by_category(
          category_id,
          token
        );
        setServices(findService(response.services)); // Lưu danh sách service
      } catch (error) {
        toast.dismiss();
        toast.error(
          error.response
            ? `${error.response?.data?.message}`
            : "Không thể kết nối tới server. Vui lòng kiểm tra mạng."
        );
        console.error("Error:", error);
      } finally {
        setFetchLoading(false);
      }
    },
    [token]
  );

  const handleSearch = async () => {
    try {
      setFetchLoading(true);
      const response = await listServiceService.get_all(searchText, token);
      setServices(findSearchService(response.services));
      setSelectedCategory("");
    } catch (error) {
      toast.dismiss();
      toast.error(
        error.response
          ? `${error.response?.data?.message}`
          : "Không thể kết nối tới server. Vui lòng kiểm tra mạng."
      );
      console.error("Error:", error);
    } finally {
      setFetchLoading(false);
    }
  };

  useEffect(() => {
    fetchCategory();
  }, [fetchCategory]);

  useEffect(() => {
    if (selectedCategory) {
      fetchService(selectedCategory.id);
    }
  }, [selectedCategory, fetchService]);
  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loading />
      </div>
    );
  }
  if (!isOpen) return null;
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-end z-50"
      onClick={onClose}
    >
      <div
        className="w-1/2 bg-white h-full p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center pb-4 mb-4 border-b">
          <h2 className="text-lg font-bold text-[#056BDA]">Tạo dịch vụ</h2>
          <button onClick={onClose} className="text-gray-600 hover:text-black">
            <img src="/icons/x-close.svg" alt="close icon" />
          </button>
        </div>
        <div className="flex flex-col gap-4">
          <SearchBar
            searchText={searchText}
            setSearchText={setSearchText}
            onSearch={handleSearch}
          />
          <FilterButtons
            category={category}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
          />
          <div className="max-h-[calc(100vh-280px)] overflow-auto py-2">
            {fetchLoading ? (
              <div className="flex  mt-32 h-full items-center justify-center">
                <Loading />
              </div>
            ) : (
              <ServiceItems id={id} items={services} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidePopup;
